'use client'
import { useEffect, useState } from 'react'

type INameWith = 'large' | 'desktop' | 'laptop' | 'tablet' | 'mobile'

const useScreenWidth = () => {
  const [screenWidth, setScreenWidth] = useState<number>(0)

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth)
    window.addEventListener('resize', handleResize)
    handleResize()
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return {
    screenWidth: nameWindow(screenWidth),
    screenName: getScreenName(screenWidth),
    isDesktop: nameWindow(screenWidth) === 'desktop',
    sizeWindow: screenWidth,
  }
}

const nameWindow = (value: number): 'desktop' | 'mobile' => {
  if (value > 1024) return 'desktop'

  return 'mobile'
}

const getScreenName = (value: number): INameWith => {
  switch (true) {
    case value >= 1920: {
      return 'large'
    }
    case value >= 1440: {
      return 'desktop'
    }
    case value >= 1024: {
      return 'laptop'
    }
    case value >= 768: {
      return 'tablet'
    }
    default: {
      return 'mobile'
    }
  }
}

export default useScreenWidth
